export const fncGetClients = (state, payload) => {

    for( var p in payload ) {
        payload[p].client_name = payload[p].client_name + ' ( #' + payload[p].id + ' )';
    }

    state.setupClients = payload;
}

export const fncRetrieveKams = (state, payload) => {
    for( var p in payload ) {
        payload[p].fullname = payload[p].name + ' ' + payload[p].surname;

      var cipherEmail = payload[p].email;
        cipherEmail = atob(cipherEmail);
        cipherEmail = atob(cipherEmail);
        cipherEmail = atob(cipherEmail);
        cipherEmail = atob(cipherEmail);

        var objCipher = cipherEmail.split('|');

        payload[p].email = objCipher[1];

    }

    state.kamUsers = payload;
}

export const fncSetAttachmentCategory = (state, payload) => {
  var noCategory = { id: 0, name: 'Not Categorized' };
  payload.unshift(noCategory);
  state.attachmentCategories = payload;
}

export const fncEmptyAttachmentCategories = (state, payload) => {
  state.attachmentCategories = [];
}

export const fncSetManufacturerToken = (state, payload) => {
  state.manufacturerToken = payload;
}


